export default __webpack_public_path__ + "static/organizations-4-d9ef5994f445200c69f9b34f7fc95fc0.jpg";